/** Move a WeChat callback out of the small QR frame into its containing authentication frame. */
export const resumeEmbeddedWeChat = (context: Window = window): boolean => {
  try {
    if (
      context.parent === context ||
      context.frameElement?.getAttribute('data-unlimitai-wechat-embedded') !== 'true' ||
      context.parent.location.origin !== context.location.origin
    ) {
      return false;
    }
    // The sandbox blocks child-driven ancestor navigation; the parent performs it.
    context.parent.postMessage(
      { type: 'unlimitai:wechat-resume', url: context.location.href },
      context.location.origin
    );
    return true;
  } catch {
    // Cross-origin frames cannot access the authentication window and are not relayed.
    return false;
  }
};

/** Only the marked QR child may request same-origin authentication navigation. */
export const getWeChatResumeUrl = (
  event: MessageEvent<unknown>,
  frame: Pick<HTMLIFrameElement, 'contentWindow'> | undefined,
  origin: string
): string | undefined => {
  if (!frame?.contentWindow || event.source !== frame.contentWindow || event.origin !== origin) {
    return;
  }
  const { data } = event;
  if (
    !data ||
    typeof data !== 'object' ||
    !('type' in data) ||
    data.type !== 'unlimitai:wechat-resume' ||
    !('url' in data) ||
    typeof data.url !== 'string'
  ) {
    return;
  }
  try {
    const url = new URL(data.url);
    if (url.origin === origin && !url.username && !url.password) {
      return url.href;
    }
  } catch {
    // Invalid callback messages are ignored without changing the active session.
  }
};
